import { AuthPage } from "@refinedev/antd";

export const Login = () => {
  return (
    <AuthPage
      type="login"
      title="Smart Tech App"
      registerLink={false}
      rememberMe={false}
      // formProps={{
      //   initialValues: { email: "demo@refine.dev", password: "demodemo" },
      // }}
    />
  );
};
